const CHECKOUT_URL = 'https://web.tevh.in/o5d9';

export function getCheckoutUrl() {
  const params = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();

  for (const [key, value] of params.entries()) {
    if (key.startsWith('utm_')) {
      utmParams.set(key, value);
    }
  }

  const utmString = utmParams.toString();
  return utmString ? `${CHECKOUT_URL}?${utmString}` : CHECKOUT_URL;
}
